import axios from '../Utility/axiosconfig'

const commonBidding = async (body) => {
    await axios.post('mobileapi/mobileconfirmForward', body)
    return true
}

export default commonBidding
